module.exports = require("node:worker_threads");